/* eslint-disable import/prefer-default-export */
export const infoSheetConstants = {
  SEND_INFOSHEET_REQUEST: 'SEND_INFOSHEET_REQUEST',
  SEND_INFOSHEET_SUCCESS: 'SEND_INFOSHEET_SUCCESS',
  SEND_INFOSHEET_FAILURE: 'SEND_INFOSHEET_FAILURE',

  LOAD_INFOSHEET_REQUEST: 'LOAD_INFOSHEET_REQUEST',
  LOAD_INFOSHEET_SUCCESS: 'LOAD_INFOSHEET_SUCCESS',
  LOAD_INFOSHEET_FAILURE: 'LOAD_INFOSHEET_FAILURE',

  UPDATE_INFOSHEET_REQUEST: 'UPDATE_INFOSHEET_REQUEST',
  UPDATE_INFOSHEET_SUCCESS: 'UPDATE_INFOSHEET_SUCCESS',
  UPDATE_INFOSHEET_FAILURE: 'UPDATE_INFOSHEET_FAILURE',
};
